import { __decorate } from "tslib";
import { throttle } from 'helpful-decorators';
import $ from 'jquery';
export default class ResponsiveVideo {
    static $element = $('.js__responsive-video');
    static init() {
        $(window).on('resize', this.handleResize.bind(this));
        this.handleResize();
    }
    static handleResize() {
        this.$element.each((_, element) => {
            const $video = $(element);
            const $sources = $video.find('source');
            const $activeSource = $sources.filter('[src]');
            const $matchingSources = $sources
                .filter('[data-media]')
                .filter((_, source) => window.matchMedia($(source).data('media')).matches);
            const $matchingSource = $matchingSources.length > 0 ? $matchingSources.first() : $sources.filter(':not([data-media])');
            if (!$activeSource.is($matchingSource.get(0))) {
                const isPlaying = !element.paused && !element.ended;
                $activeSource.removeAttr('src');
                $matchingSource.attr('src', $matchingSource.data('src'));
                $video.attr('src', $matchingSource.data('src'));
                if (isPlaying) {
                    element.play();
                }
            }
        });
    }
}
__decorate([
    throttle(300)
], ResponsiveVideo, "handleResize", null);
